import axios from "axios";
import persianToEnglishNumbers from "./tools/farsiToEnglishNumber";

export const primaryMediaBaseUrl = "https://atropine.ir";
export const backupMediaBaseUrl = "https://drnayebzadehapp.ir";
const baseUrl = "https://atropine.ir/api/";
const STATIC_TOKEN = "MQ==";

const encodeToBase64 = (text) => btoa(text);

const createFormData = (token) => {
  const formData = new FormData();
  formData.append("Token", token);
  return formData;
};

export const login = async (phone) => {
  try {
    return await axios.get(`${baseUrl}LoginRegister.aspx?phone=${phone}`);
  } catch (error) {
    console.error("API Error in login:", error);
    throw error;
  }
};

export const verifySMSCode = async (phone, smscode) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}VerifySMSCode.aspx?phone=${phone}&smscode=${smscode}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in verifySMSCode:", error);
    throw error;
  }
};

export const uploadCenter = async (phone) => {
  try {
    const token = encodeToBase64(phone);
    const formData = createFormData(token);
    return await axios.post(`${baseUrl}UploadCenter.aspx?phone=${phone}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in uploadCenter:", error);
    throw error;
  }
};

export const getSliders = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(baseUrl + "SliderWeb.aspx", formData);
    return data;
  } catch (error) {
    console.error("API Error in getSliders:", error);
    throw error;
  }
};

export const getCategory = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(baseUrl + "Category.aspx", formData);
  } catch (error) {
    console.error("API Error in getCategory:", error);
    throw error;
  }
};

export const getAllSubCategory = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(baseUrl + "SubCategory.aspx", formData);
    return data;
  } catch (error) {
    console.error("API Error in getAllSubCategory:", error);
    throw error;
  }
};

export const getSubCategory = async (categoryID) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}SubCategory.aspx?categoryID=${categoryID}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in getSubCategory:", error);
    throw error;
  }
};

export const getProducts = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(baseUrl + "Product.aspx", formData);
    return data;
  } catch (error) {
    console.error("API Error in getProducts:", error);
    throw error;
  }
};

export const getCategoryID = async (id) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}Product.aspx?CategoryID=${id}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in getCategoryID:", error);
    throw error;
  }
};

export const getSubCategoryID = async (id) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}Product.aspx?subCategoryID=${id}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in getSubCategoryID:", error);
    throw error;
  }
};

export const getProduct = async (id) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}Product.aspx?productID=${id}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in getProduct:", error);
    throw error;
  }
};

export const getProductChildren = async (parentId) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}Product.aspx?productAsliId=${parentId}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in getProductChildren:", error);
    throw error;
  }
};

export const getProductComment = async (id) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}ProductComment.aspx?productID=${id}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in getProductComment:", error);
    throw error;
  }
};

export const getProductImage = async (id) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}ProductImage.aspx?productID=${id}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in getProductImage:", error);
    throw error;
  }
};

export const getProductProperty = async (id) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}ProductProperty.aspx?productID=${id}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in getProductProperty:", error);
    throw error;
  }
};

export const setProductComment = async (id, phone, description, username) => {
  try {
    const token = encodeToBase64(phone);
    const formData = createFormData(token);
    return await axios.post(
      `${baseUrl}SetComment.aspx?phone=${phone}&productid=${id}&description=${description}&username=${username}&userfamily=${username}&score=5`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in setProductComment:", error);
    throw error;
  }
};

export const setFavorite = async (id, phone) => {
  try {
    const token = encodeToBase64(phone);
    const formData = createFormData(token);
    return await axios.post(`${baseUrl}SetFavorite.aspx?Phone=${phone}&productid=${id}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in setFavorite:", error);
    throw error;
  }
};

export const deleteFavorite = async (id, phone) => {
  try {
    const token = encodeToBase64(phone);
    const formData = createFormData(token);
    return await axios.post(`${baseUrl}DeleteFavorite.aspx?Phone=${phone}&productid=${id}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in deleteFavorite:", error);
    throw error;
  }
};

export const favoriteCheck = async (id, phone) => {
  try {
    const token = encodeToBase64(phone);
    const formData = createFormData(token);
    return await axios.post(`${baseUrl}FavoriteCheck.aspx?Phone=${phone}&productid=${id}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in favoriteCheck:", error);
    throw error;
  }
};

export const userFavorite = async (phone) => {
  try {
    const token = encodeToBase64(phone);
    const formData = createFormData(token);
    return await axios.post(`${baseUrl}UserFavorite.aspx?Phone=${phone}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in userFavorite:", error);
    throw error;
  }
};

export const specialProduct = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(baseUrl + "SpecialProduct.aspx", formData);
    return data;
  } catch (error) {
    console.error("API Error in specialProduct:", error);
    throw error;
  }
};

export const productPackage = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(baseUrl + "PackageProduct.aspx", formData);
    return data;
  } catch (error) {
    console.error("API Error in productPackage:", error);
    throw error;
  }
};

export const topProduct = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(baseUrl + "TopProduct.aspx", formData);
    return data;
  } catch (error) {
    console.error("API Error in topProduct:", error);
    throw error;
  }
};

export const moshabeh = async (id) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}moshabeh.aspx?productid=${0}&mainProductId=${id}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in moshabeh:", error);
    throw error;
  }
};

export const searchQ = async (id) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}Product.aspx?Search=${id}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in searchQ:", error);
    throw error;
  }
};

export const aboutUs = async () => { // Add the static token
  try {
    const formData = createFormData(STATIC_TOKEN);
    const {data} = await axios.post(baseUrl + "AboutUs.aspx", formData);
    return data;
  } catch (error) {
    console.error("API Error in aboutUs:", error);
    throw error;
  }
};

export const ContactUs = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}ContactUs.aspx`, formData);
    return data;
  } catch (error) {
    console.error("API Error in ContactUs:", error);
    throw error;
  }
};

export const SetProfile = async (phonenumber, firstname, lastname, email, maghta) => {
  try {
    const token = encodeToBase64(phonenumber);
    const formData = createFormData(token);
    return await axios.post(
      `${baseUrl}SetProfile.aspx?phone=${phonenumber}&name=${firstname}&family=${lastname}&email=${email}&password=1111&maghta=${maghta}`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in SetProfile:", error);
    throw error;
  }
};

export const UserDetail = async (phonenumber) => {
  try {
    const token = encodeToBase64(phonenumber);
    const formData = createFormData(token);
    return await axios.post(`${baseUrl}UserDetail.aspx?phone=${phonenumber}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in UserDetail:", error);
    throw error;
  }
};

export const BasketHistory = async (phonenumber) => {
  try {
    const token = encodeToBase64(phonenumber);
    const formData = createFormData(token);
    return await axios.post(`${baseUrl}BasketHistory.aspx?phone=${phonenumber}`, formData);
  } catch (error) {
    console.error("API Error in BasketHistory:", error);
    throw error;
  }
};

export const BasketHistoryDeatils = async (id) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}BasketDetailHistory.aspx?basketID=${id}`, formData);
  } catch (error) {
    console.error("API Error in BasketHistoryDeatils:", error);
    throw error;
  }
};

export const SetNote = async (id, note) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}SetNote.aspx?id=${id}&note=${note}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in SetNote:", error);
    throw error;
  }
};

export const SetAddres = async (phonenumber, title, address, lat, long, postalcode, name, family) => {
  try {
    const token = encodeToBase64(phonenumber);
    const formData = createFormData(token);
    return await axios.post(
      `${baseUrl}SetAddress.aspx?phone=${phonenumber}&title=${title}&address=${address}&maplat=${lat}&maplong=${long}&codePosti=${postalcode}${name ? `&name=${name}&family=${family}` : ""}`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in SetAddres:", error);
    throw error;
  }
};

export const UserAddress = async (phonenumber) => {
  try {
    const token = encodeToBase64(persianToEnglishNumbers(phonenumber));
    const formData = createFormData(token);
    return await axios.post(`${baseUrl}UserAddress.aspx?phone=${phonenumber}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in UserAddress:", error);
    throw error;
  }
};

export const VerifyTakhfif = async (code) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}VerifyTakhfif.aspx?takhfifcode=${code}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in VerifyTakhfif:", error);
    throw error;
  }
};

export const payBasket = async (basketId) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}BasketPayment.aspx?basketId=${basketId}`, formData);
    return data;
  } catch (error) {
    console.error("API Error in payBasket:", error);
    throw error;
  }
};

export const SetBasket = async (
  phone,
  addressid,
  totalAmount,
  disprice,
  discode,
  distrue,
  description,
  shippingAmount,
  isMoshaverePackage
) => {
  console.log(`${baseUrl}SetBasket.aspx?phone=${phone}&addressid=${addressid}&Discountedprice=${totalAmount}&basketPrice=${disprice}&discountedCode=${
        discode || "-"
      }&isdiscounted=${distrue}&description=${description}&shippingAmount=${shippingAmount}&isSite=true&ismpackage=${isMoshaverePackage}`);
  
  try {
    const token = encodeToBase64(persianToEnglishNumbers(phone));
    const formData = createFormData(token);
    return await axios.post(
      `${baseUrl}SetBasket.aspx?phone=${phone}&addressid=${addressid}&Discountedprice=${totalAmount}&basketPrice=${disprice}&discountedCode=${
        discode || "-"
      }&isdiscounted=${distrue}&description=${description}&shippingAmount=${shippingAmount}&isSite=true&ismpackage=${isMoshaverePackage}`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in SetBasket:", error);
    throw error;
  }
};

export const SetBasketDetail = async (phone, basketid, productid, count, finalPrice) => {
  try {
    const token = encodeToBase64(persianToEnglishNumbers(phone));
    const formData = createFormData(token);
    return await axios.post(
      `${baseUrl}SetBasketDetail.aspx?phone=${phone}&basketid=${basketid}&count=${count}&productID=${productid}&description='-'&priceTakhfif=${finalPrice}`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in SetBasketDetail:", error);
    throw error;
  }
};

export const SetFlashCartBasketDetail = async (phone, basketid, productid) => {
  try {
    const token = encodeToBase64(phone);
    const formData = createFormData(token);
    return await axios.post(
      `${baseUrl}SetBasketDetailFlash.aspx?phone=${phone}&basketid=${basketid}&count=1&productID=${productid}&description='-'`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in SetFlashCartBasketDetail:", error);
    throw error;
  }
};

export const Payment = async (basketid, amount) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(
      `${baseUrl}Payment.aspx?basketid=${basketid}&amount=${amount}`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in Payment:", error);
    throw error;
  }
};

export const getStatisticsCounters = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}SiteNumber.aspx`, formData);
    return data;
  } catch (error) {
    console.error("API Error in getStatisticsCounters:", error);
    throw error;
  }
};

export const Moshavereh = async (phone, name, text) => {
  try {
    const token = encodeToBase64(phone);
    const formData = createFormData(token);
    return await axios.post(
      `${baseUrl}SetMoshavere.aspx?phone=${phone}&name=${name}&text=${text}`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in Moshavereh:", error);
    throw error;
  }
};

export const GetMoshaverehData = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}Moshavereh.aspx`, formData);
    return data;
  } catch (error) {
    console.error("API Error in GetMoshaverehData:", error);
    throw error;
  }
};

// Get Moshavere packages
export const getMoshaverehPackages = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}MoshaverePackageProduct.aspx`, formData);
    return data;
  } catch (error) {
    console.error("API Error in getMoshaverehPackages:", error);
    throw error;
  }
};

export const CommingSoonProduct = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}CommingSoonProduct.aspx`, formData);
    return data;
  } catch (error) {
    console.error("API Error in CommingSoonProduct:", error);
    throw error;
  }
};

// هزینه پست
export const ShippingAmount = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}ShippingAmount.aspx`, formData);
    return data;
  } catch (error) {
    console.error("API Error in ShippingAmount:", error);
    throw error;
  }
};

// ----------------------------------------- FLASH CART
export const FlashFavoriteCheck = async (phone, productid) => {
  try {
    const token = encodeToBase64(persianToEnglishNumbers(phone));
    const formData = createFormData(token);
    return await axios.post(
      `${baseUrl}FlashFavoriteCheck.aspx?phone=${phone}&productid=${productid}`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in FlashFavoriteCheck:", error);
    throw error;
  }
};

export const DeleteFlashFavorite = async (phone, productid) => {
  try {
    const token = encodeToBase64(persianToEnglishNumbers(phone));
    const formData = createFormData(token);
    return await axios.post(
      `${baseUrl}DeleteFlashFavorite.aspx?phone=${phone}&productid=${productid}`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in DeleteFlashFavorite:", error);
    throw error;
  }
};

export const SetFlashFavorite = async (phone, productid, subCategoryId) => {
  try {
    const token = encodeToBase64(persianToEnglishNumbers(phone));
    const formData = createFormData(token);
    return await axios.post(
      `${baseUrl}SetFlashFavorite.aspx?phone=${phone}&productid=${productid}&subCategoryID=${subCategoryId}`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in SetFlashFavorite:", error);
    throw error;
  }
};

export const UserFlashFavorite = async (phone) => {
  try {
    const token = encodeToBase64(persianToEnglishNumbers(phone));
    const formData = createFormData(token);
    return await axios.post(
      `${baseUrl}UserFlashFavorite.aspx?phone=${phone}`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in UserFlashFavorite:", error);
    throw error;
  }
};

// ------------------------------------------- BLOG

export const getBlog = async (categoryid = null) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(
      categoryid ? `${baseUrl}Blog.aspx?categoryid=${categoryid}` : `${baseUrl}Blog.aspx`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in getBlog:", error);
    throw error;
  }
};

export const getBlogById = async (id) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(
      `${baseUrl}Blog.aspx?BlogID=${id}`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in getBlogById:", error);
    throw error;
  }
};

export const getCategoryBlog = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}CategoryBlog.aspx`, formData);
    return data;
  } catch (error) {
    console.error("API Error in getCategoryBlog:", error);
    throw error;
  }
};

export const getCategoryBlogById = async (id) => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(
      `${baseUrl}Blog.aspx?CategoryID=${id}`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in getCategoryBlogById:", error);
    throw error;
  }
};

export const getStudioList = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(
      `${baseUrl}studioList.aspx`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in getStudioList:", error);
    throw error;
  }
};

// -------------------------------------------- MOSHAVERE PAGE BLOGS

export const getConsultationBlogs = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}BlogMoshavere.aspx`, formData);
    return data;
  } catch (error) {
    console.error("API Error in getConsultationBlogs:", error);
    throw error;
  }
};

// -------------------------------------------- دعوت از دوستان
export const davatFreinds = async (phone) => {
  try {
    const token = encodeToBase64(persianToEnglishNumbers(phone));
    const formData = createFormData(token);
    return await axios.post(
      `${baseUrl}Davat.aspx?phone=${phone}`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in davatFreinds:", error);
    throw error;
  }
};

// -------------------------------------------- ثبت درخواست همکاری
export const setHamkariDavat = async (phone, name, text) => {
  
  try {
    const token = encodeToBase64(persianToEnglishNumbers(phone));
    const formData = createFormData(token);
    return await axios.post(
      `${baseUrl}SetHamkari.aspx?phone=${phone}&name=${name}&text=${text}`,
      formData
    );
    return data;
  } catch (error) {
    console.error("API Error in setHamkariDavat:", error);
    throw error;
  }
};

export const GetHamkariData = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}Hamkari.aspx`, formData);
    return data;
  } catch (error) {
    console.error("API Error in GetHamkariData:", error);
    throw error;
  }
};

// ------------------------------- download App
export const atropinApplication = async () => {
  try {
    const formData = createFormData(STATIC_TOKEN);
    return await axios.post(`${baseUrl}DownloadAPK.aspx`, formData);
    return data;
  } catch (error) {
    console.error("API Error in atropinApplication:", error);
    throw error;
  }
};

